export const SET_CHALLENGES = 'SET_CHALLENGES'
export const SET_CHALLENGE = 'SET_CHALLENGE'
export const RESET_CHALLENGE = 'RESET_CHALLENGE'
export const RESET_CHALLENGES = 'RESET_CHALLENGES'
export const SET_CHALLENGE_DATA = 'SET_CHALLENGE_DATA'
export const SAVED_CHALLENGE = 'SAVED_CHALLENGE'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_PAGER = 'SET_PAGER'
export const SET_CHALLENGENAME = 'SET_CHALLENGENAME'

export const STORE_PAGER = 'challenges/pager'
